module.exports = __webpack_public_path__ + "img/spongebobs_alarm_clock.73d285a9.jpg";